import React from 'react';

function TodosError() {
  return <p>Ocurrio un error</p>
};

export { TodosError };